import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { DashboardProrrogado } from '../domain/dashboard-prorrogado.model';

export class DashBoardProrrogadoSerializer extends DomainSerializer<DashboardProrrogado> { }
